<template>
    <div id="confirmation-reservation" class="popin-modal centered" v-show="isPopinDisplayed" v-observe-visibility="{ callback: popin_confirmationReservationDisplayed_callback }">
        <div class="popin-container">
            <div class="popin-closure" v-on:click="popin_confirmationReservationClosed">
                <div class="arrow">X</div>
            </div>
            <div class="popin-closure-responsive" v-on:click="popin_confirmationReservationClosed">
                <div class="arrow">X</div>
            </div>
            <div class="popin">
                <div class="popin-content">
                    <div class="popin-content-container">
                        <p>&nbsp;</p>
                        <p>
                            <template v-if="reservation_status">Votre réservation pour <span>{{ destination_label }}</span> a été confirmée !</template>
                            <template v-else>Votre réservation pour <span>{{ destination_label }}</span> n'a pas été validée.</template>
                        </p>
                        <p>&nbsp;</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

import anime from 'animejs/lib/anime.es';
import axios from 'axios';

export default {
    name: "ConfirmationReservation",
    components: {},
    data: () => ({
        // popin parameters
        isPopinDisplayed: false,
        // data
        destination_label: null,
        reservation_status: false
    }),
    methods: {
        popin_confirmationReservationDisplayed: function(destination_label, reservation_status) {
           this.destination_label = destination_label;
           this.reservation_status = reservation_status;
           this.isPopinDisplayed = true;
        },
        popin_confirmationReservationClosed: function() {
            var self = this;
            anime({
                targets: 'div#confirmation-reservation.popin-modal > div.popin-container',
                opacity: [1, 0],
                duration: 250,
                easing: 'linear',
                complete: function(anime) {
                    self.isPopinDisplayed = false;
                }
            });
        },
        popin_confirmationReservationDisplayed_callback(visible, entry) {
            if (!visible) {
                return;
            }

            var self = this;
            anime({
                targets: 'div#confirmation-reservation.popin-modal > div.popin-container',
                opacity: [0, 1],
                duration: 250,
                easing: 'linear',
                complete: function(anim) {
                    if (self.reservation_status) {
                        gtag('event', 'conversion', {'send_to': 'AW-700467994/1aS_CNiP-YoYEJqWgc4C'});
                    }

                    // Suppression de la pré-réservation
                    axios.delete('https://api.lockquest.fr/creneau/reservation_in_progress');
                }
            });
        }
    }
}
</script>